// Library Imports
import React, { FC, useEffect, useState } from 'react';
import TableSkeleton from '../Skeleton/TableSkeleton';

type TableBodyProps = {
  rows: any[];
  columns: any[];
  selectedIds: Number[];
  setSelectedIds: Function;
  tableColumnExtensions: any;
  dataProviders?: any;
  onRowClick?: Function;
  loading?: Boolean;
  isRowsEditable?: Boolean;
  editingIds?: string[] | null;
  setEditingIds?: Function;
};

const TableMainBody: FC<TableBodyProps> = ({
  rows,
  columns,
  selectedIds,
  setSelectedIds,
  tableColumnExtensions,
  dataProviders,
  onRowClick,
  loading,
  isRowsEditable,
  editingIds
}) => {
  console.log('editingIds', editingIds);
  // STATES
  const [editedRowData, setEditedRowData] = useState<any>({});

  useEffect(() => {
    if (!editingIds?.length) return;

    setEditedRowData((prev: any) => {
      const updated = { ...prev };

      editingIds.forEach(id => {
        if (!updated[id]) {
          const row = rows.find(r => r.id === id);
          if (row) {
            updated[id] = { ...row };
          }
        }
      });

      return updated;
    });
  }, [editingIds, rows]);

  if (loading) {
    return <TableSkeleton rows={17} cols={columns.length + 1} />;
  }

  return (
    <React.Fragment>
      {rows?.length > 0 && (
        <tbody>
          {rows?.map((row, rowIndex) => {
            const id = row?.id;
            // IS SELECTED ID
            const isRowSelected = selectedIds?.includes(id);
            // ONCHANGE OF SELECTIONS CHECKBOX
            const onChange = () => {
              const ids = isRowSelected
                ? selectedIds?.filter(ele => ele !== id)
                : [...selectedIds, id];
              setSelectedIds(ids);
            };

            const isRowEdited = editingIds?.includes(id);
            return (
              <tr
                key={rowIndex}
                className='border-t border-border even:bg-gray-200 odd:bg-white hover:bg-gray-100 transition-all duration-150'
              >
                <td className='px-2'>
                  <input
                    type='checkbox'
                    className='cursor-pointer'
                    checked={Boolean(isRowSelected)}
                    onChange={onChange}
                  />
                </td>
                {columns?.map((col, colIndex) => {
                  // GET COLUMN EXTENSION
                  const columnExtension = tableColumnExtensions?.find(
                    (item: { columnName: any }) => item?.columnName === col?.name
                  );
                  // GET EXTENSION WITH
                  const dataProvider = dataProviders?.find(
                    (provider: { columnName: any[] }) => provider?.columnName[0] === col?.name
                  );

                  return (
                    <td
                      key={colIndex}
                      color={'primary'}
                      width={columnExtension?.width || 100}
                      className='text-[12px] py-3.5 px-1 bg-transparent'
                      onClick={event => {
                        event.stopPropagation();
                        if (col?.name !== 'action') {
                          onRowClick && onRowClick(row);
                        }
                      }}
                    >
                      {isRowsEditable && col?.isEditable && isRowEdited ? (
                        <input
                          type='text'
                          value={editedRowData[id]?.[col?.name] ?? row[col?.name]}
                          onChange={event => {
                            const value = event.target.value;
                            setEditedRowData((prev: any) => ({
                              ...prev,
                              [id]: {
                                ...prev[id],
                                [col.name]: value
                              }
                            }));
                          }}
                          className='border-b border-gray-500  outline-none resize-none w-full  text-darkGray text-sm py-1 bg-gray-200'
                        />
                      ) : dataProvider !== undefined ? (
                        dataProvider?.func({ row: row, updatedRow: editedRowData[id] || row })
                      ) : (
                        row[col?.name]
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      )}
    </React.Fragment>
  );
};

export default TableMainBody;
